import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { AppServiceService } from 'src/app/core/services/app-service.service';

@Component({
  selector: 'app-user-locked',
  templateUrl: './user-locked.component.html',
  styleUrls: ['./user-locked.component.scss']
})
export class UserLockedComponent implements OnInit {
  //disableButton:boolean = true;
  service:any;
  userReleased:number; 
  time:number = 0;
  interval:any;
  constructor(private appConfigService: AppConfigService  , private _appService : AppServiceService) { }

  ngOnInit(): void {
   
  //   this.service = this.appConfigService.service;
  //   this.appConfigService.getTimeUserLocked().subscribe(
  //     (data) => {
  //       this.userReleased = data;
  //     },
  //   )
  //   this.interval = setInterval(() => {
  //    this.time++;  
  //   if(this.time ==  this.userReleased)   {
  //     this.disableButton = false;                          
  //   } 
       
  //  }, 60000);
  }

  // reEntry(){
  //   this._appService.doReset(); 
  //    }
  

}
